import { render, staticRenderFns } from "./CouponHistory.vue?vue&type=template&id=fd157be8&scoped=true&"
import script from "./CouponHistory.vue?vue&type=script&lang=js&"
export * from "./CouponHistory.vue?vue&type=script&lang=js&"
import style0 from "./CouponHistory.vue?vue&type=style&index=0&id=fd157be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd157be8",
  null
  
)

export default component.exports